import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../entities/ExceptionEntity";
import UserEntity from "../entities/UserEntity";

export default interface AllUserRepository {
    search: () => Promise<Either<ExceptionEntity, UserEntity[]>>;
}

export const AllUserRepositoryName = "AllUserRepositoryName";